import React from 'react';
import ConditionPage from '../components/ConditionPage';

const Nutrition: React.FC = () => (
  <ConditionPage
    eyebrow="Nutrition"
    docTitle="Nutrition — Haven Crest Health"
    title={<>Labs, GI records, and dietitian notes, <em>in one inbox.</em></>}
    lede="A nutritional condition leaves a trail across offices: bloodwork, GI records, dietitian notes. Haven Crest gathers them into your own inbox with one-click requests sent on your behalf, then helps you make sense of them and find a dietitian or specialist. Free, and entirely your choice."
    items={[
      { icon: '🧪', title: 'Lab results over time', text: 'Every panel from every lab, requested with one click and lined up so trends are visible.' },
      { icon: '🩺', title: 'GI and metabolic records', text: 'Procedure reports and specialist notes, together with the labs that prompted them.' },
      { icon: '🥗', title: 'Dietitian notes', text: 'Plans and follow-ups from past dietitians, so a new one can start where the last left off.' },
      { icon: '⌕', title: 'Finding the right specialist', text: 'A navigator helps you locate a registered dietitian or specialist and shares your records ahead of the visit.' },
    ]}
  />
);

export default Nutrition;
